import React from 'react';
import './CreativeEditorModal.css';

export default function CreativeFileUpload({
    inputId,
    accept,
    fileName,
    isReady,
    disabled = false,
    onChange,
}) {
    const displayName = fileName || 'Choose image or video…';

    return (
        <div className={`creativeFileUpload ${isReady ? 'creativeFileUploadReady' : ''} ${disabled ? 'creativeFileUploadDisabled' : ''}`}>
            <input
                id={inputId}
                type="file"
                accept={accept}
                className="creativeFileUploadInput"
                onChange={onChange}
                disabled={disabled}
            />
            <label htmlFor={inputId} className="creativeFileUploadLabel">
                <span className="creativeFileUploadLabelText">
                    {isReady && fileName ? fileName : displayName}
                </span>
                <span className="creativeFileUploadBrowse">{isReady ? 'Replace' : 'Browse'}</span>
            </label>
            {isReady && (
                <span className="creativeUploadStatus" role="status">
                    Uploaded successfully
                </span>
            )}
        </div>
    );
}
